module.exports = __webpack_public_path__ + "img/Breastfeeding.8c9d6dcc.jpg";